import { render, staticRenderFns } from "./ModalNurse.vue?vue&type=template&id=554e9a4e"
import script from "./ModalNurse.vue?vue&type=script&lang=js"
export * from "./ModalNurse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports